export * from './document-viewer.component';
export * from './document-viewer.module';
